// Where each company document's stored link, file name and upload time live: `within` is the
// object in the listing data that holds them, or null for top-level keys. The browser and the API
// server both read the W-9 and insurance keys from this one map, and the credential key lists
// below are built from it, so a renamed key changes in one place only.
//
// Written as plain CommonJS with no imports so the API server, which runs its files under plain
// node, can require this same file the browser bundle imports.

const COMPANY_DOCUMENT_KEYS = {
  w9: { within: 'companyIdentification', url: 'w9FormUrl', name: 'w9FormName', uploadedAt: 'w9FormUploadedAt' },
  insurance: {
    within: null,
    url: 'insuranceCertificateUrl',
    name: 'insuranceCertificateName',
    uploadedAt: 'insuranceCertificateUploadedAt',
    // The date the certificate's cover ends, as the company gives it; kept with the certificate.
    expiresAt: 'insuranceCertificateExpiresAt',
  },
};

// Keys of `companyIdentification` that are credential data. Its other keys stay public. Read from
// the map each time, so they always follow it.
const companyIdCredentialKeys = () => {
  const w9 = COMPANY_DOCUMENT_KEYS.w9;
  return ['identificationNumber', 'w9Form', w9.name, w9.url, w9.uploadedAt];
};

// Top-level keys for the insurance certificate.
const insuranceKeys = () => {
  const insurance = COMPANY_DOCUMENT_KEYS.insurance;
  return [insurance.url, insurance.name, insurance.uploadedAt, insurance.expiresAt].filter(Boolean);
};

module.exports = {
  COMPANY_DOCUMENT_KEYS,
  companyIdCredentialKeys,
  insuranceKeys,
};
